import { useEffect, useRef } from "react";

export default function ContactIntro() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("opacity-100", "translate-y-0");
          entry.target.classList.remove("opacity-0", "translate-y-6");
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-14 md:py-16 bg-white">
      <div
        ref={ref}
        className="max-w-7xl mx-auto px-4 md:px-8 opacity-0 translate-y-6 transition-all duration-700"
      >
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-green-50 text-[#1B4D2E] text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wider">
            <i className="ri-customer-service-2-line"></i>
            We&apos;re Here to Help
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B4D2E] mb-5">
            Talk to Our Team
          </h2>
          <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
            Our team is available for enquiries about residential projects, villa plots, premium villas, property consultations, and site visits across Bengaluru. Whether you&apos;re a first-time buyer or a seasoned investor, we&apos;re here to guide you to the right property on Sarjapur Road, Bangalore.
          </p>
          <a
            href="https://wa.me/919876543210"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold text-sm px-7 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base"></i>
            WhatsApp Now
          </a>
        </div>
      </div>
    </section>
  );
}
